// Shared "nothing here" state. Replaces the bare <p className="muted">No items…</p>
// scattered across the tab bodies: those stated the fact but not the way out, so a
// user who had filtered themselves into an empty grid had no next step. Modelled on
// the one good existing case (UnreconciledTab's "N of M items match" + Clear search).
interface Props {
  title: string;
  /** What to do about it. Omit when there is genuinely nothing to do. */
  body?: string;
  icon?: string;
  /** Recovery affordance — e.g. clearing the filter that emptied the view. */
  action?: { label: string; onClick: () => void };
}

export default function EmptyState({ title, body, icon = "◦", action }: Props) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon" aria-hidden="true">{icon}</span>
      <span className="empty-state-title">{title}</span>
      {body && <p className="empty-state-body">{body}</p>}
      {action && (
        <button type="button" className="btn" onClick={action.onClick}>{action.label}</button>
      )}
    </div>
  );
}
